import PrecallSurvey from '@components/pages/account/survey/PrecallSurvey';
import { SurveyStep } from '@components/pages/account/survey/PrecallSurvey/constants';

export const PrecallPharmacies = () => <PrecallSurvey step={SurveyStep.PHARMACY} />;

export default PrecallPharmacies;
